import { IPlaylistMediaItem } from "./playlists";

export interface IPlaylistItem {
    [x: string]: any;
    playlistId: string;
    title: string;
    subtitle: string;
    svgSrc: string;
}

export interface IPropsBasicModal {
    show: boolean;
    onHide: () => void;
    onOpenPreview?: () => void;
}

export interface TemplateCardProps {
    title: string;
    subtitle: string;
    svgSrc?: string;
    showChevron?: boolean;
    showDragIcon?: boolean;
    compact?: boolean;
    showToggle?: boolean;
    toggleValue?: boolean;
    onClick?: () => void;
    onToggle?: (value: boolean) => void;
}

export interface Playlist {
    playlistId: string;
    title: string;
    templateId?: number;

}

export interface IPlaylistMediaItems {
    mediaId: string;
    title: string;
    thumbnailUrl: string;
}

export interface ISelectTemplateProps {
    show: boolean;
    onHide: () => void;
    originalData: IPlaylistMediaItem[];
    data: IPlaylistMediaItem[];
    setData: React.Dispatch<React.SetStateAction<IPlaylistMediaItem[]>>;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    fetchPlaylist: () => Promise<void>;
    playlist: any;
}

export interface IReorderProps {
    selectedVideos: IPlaylistMediaItem[];
    mediaItems: IPlaylistMediaItem[];
    setmediaItems: React.Dispatch<React.SetStateAction<IPlaylistMediaItem[]>>;
    show: boolean;
    onHide: () => void;
}

export enum TemplateBlockType {
    PLAYLIST = 0,
    VOD_GENERAL = 1,
    VOD_FILM_FESTIVAL = 2,
    LIVESTREAM = 3,
}

export interface TemplateOrderItem {
    orderNumber: number;
    blockId: number;
    blockType: TemplateBlockType;
}

export interface BlockWithInfo {
    blockId: string;
    title: string;
    subtitle: string;
    svgSrc: string;
    blockType?: TemplateBlockType;
    numb?: number;
}

export type OrderedBlockItem = BlockWithInfo & {
    orderNumber: number;
};

export interface UpdateTemplateOrderRequest {
    order: TemplateOrderItem[];
}

export interface GetTemplateOrderResponse {
    [x: string]: any;
    data: {
        clientId: string;
        order: TemplateOrderItem[];
    };
    error: any;
}

